import { useRouterCanGoBackParamSubscriber } from '@/features/navigation/hooks/can-go-back'
import OrderFinalization from '@/features/pos/components/OrderFinalization'
import EditCartItemProvider from '@/features/pos/components/OrderFinalization/contexts/EditCartItemProvider'
import { useScreenLayout } from '@/hooks/screen'
import { Redirect } from 'expo-router'
import { FC } from 'react'

const OrderFinalizationPage: FC = () => {
    useRouterCanGoBackParamSubscriber()

    const screenLayout = useScreenLayout()

    if (screenLayout === 'extended') return <Redirect href="/orders" />

    return (
        <EditCartItemProvider>
            <OrderFinalization />
        </EditCartItemProvider>
    )
}

export default OrderFinalizationPage
